import { useNavigate } from "react-router-dom";
import MobileTailwind from "./MobileTailwind";
import BottomNav from "./components/BottomNav";
import SubHeader from "./components/SubHeader";
import Swal from "sweetalert2";

const Profile = () => {
  const navigate = useNavigate();
  const user_info = localStorage.getItem("user_info");
  const user = user_info ? JSON.parse(user_info) : null;

  const onHandleLogout = () => {
    Swal.fire({
      title: "Logout",
      text: "Are you want to Sure logout",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#F15A29",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel"
    }).then((result) => {
      if (result.isConfirmed) {
        const posWebUrl = localStorage.getItem("pos_web_url");
        localStorage.removeItem("access_token");
        localStorage.removeItem("tenantId");
        localStorage.removeItem("user_info");
        localStorage.removeItem("pos_web_url");
        sessionStorage.clear();
        if (posWebUrl) {
          window.location.href = posWebUrl;
        } else {
          navigate("/mobile/login");
        }
      }
    });
  }

  return (
    <>
      <MobileTailwind />
      <div id="mobile-root" className="h-screen w-full bg-black flex justify-center overflow-hidden">
        <div className="relative w-full h-screen overflow-y-auto overflow-x-hidden">
          {/* Background image + overlay */}
          <div className="absolute inset-0 z-0">
            <img src="/mobile-assets/login-bg.jpg" alt="" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-black/80" />
          </div>

          <div className="relative z-10">
            {/* Header */}
            <SubHeader title="Profile" showBack={false} />

            {/* Body */}
            <div className="px-3 md:px-6 pt-4 pb-[120px] flex flex-col gap-3 md:max-w-[600px] md:mx-auto md:w-full">
              {/* User card */}
              <div className="bg-white rounded-[6px] border border-[#E6EEFF] p-4 flex flex-col items-center gap-2">
                <div className="w-16 h-16 rounded-full bg-[#F4F4F5] flex items-center justify-center">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="8" r="4" stroke="#111" strokeWidth="2" />
                    <path d="M4 20c1.5-3.5 5-5 8-5s6.5 1.5 8 5" stroke="#111" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                </div>
                <p className="font-sansation font-bold text-[#111] text-[18px]"> {user?.name} </p>
                <p className="font-opensans text-[14px] text-[#8F9098]">  {user?.mobile}  </p>
              </div>

              {/* Menu */}
              <div className="bg-white rounded-[6px] border border-[#E6EEFF] overflow-hidden">
                <button type="button" onClick={() => navigate("/mobile/orders")} className="w-full text-left px-4 py-3 font-opensans text-[14px] text-[#111] bg-white border-0 flex items-center justify-between" >
                  My Orders
                  <span className="text-[#8F9098]">›</span>
                </button>
                <div className="h-px bg-[#E6EEFF] mx-4" />
                <button type="button" onClick={() => { onHandleLogout() }} className="w-full text-left px-4 py-3 font-opensans text-[14px] text-[#931314] bg-white border-0 flex items-center justify-between"  >
                  Logout
                  <span className="text-[#8F9098]">›</span>
                </button>
              </div>
            </div>
            <BottomNav active="profile" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
